<div class="modal-content" cdkTrapFocus [cdkTrapFocusAutoCapture]="false">
  <div class="modal-header">
    <h1 class="modal-title pull-left" aria-hidden="true">
      {{ title | globalTranslate }}
    </h1>
    <button
      type="button"
      class="btn-close pull-right"
      [attr.aria-label]="'CLOSE' | globalTranslate"
      (click)="onCancel()"
    >
      <img
        src="../../assets/images/⚛️ icons-close-circle-outline.svg"
        alt="close-icon"
      />
    </button>
  </div>
  <div class="modal-body">
    <h2 class="page-header sr-only" role="heading" aria-level="1">
      {{ title | globalTranslate }}
    </h2>
    <p>
      <b>{{ "HEALTH_PLAN_CANCEL_MODAL_TEXT" | globalTranslate }}</b>
    </p>
    <p>{{ "HEALTH_PLAN_CANCEL_MODAL_TEXT2" | globalTranslate }}</p>
  </div>
  <div class="modal-footer justify-content-start">
    <div class="me-2 ml-2">
      @if (showConfirm) {
      <button
        type="button"
        id="dialog"
        [attr.aria-label]="'CANCEL_REQUEST' | globalTranslate"
        class="btn d-grid btn-secondary"
        (click)="onConfirm()"
      >
        {{ confirmButton | globalTranslate }}
      </button>
      }
    </div>
    <div class="me-2 ml-2">
      @if (showDecline) {
      <button
        type="button"
        id="dialog"
        [attr.aria-label]="'EXIT' | globalTranslate"
        class="btn d-grid btn-link"
        (click)="onCancel()"
      >
        {{ declineButton | globalTranslate }}
      </button>
      }
    </div>
  </div>
</div>